import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import styled from "styled-components";
import { ActionIconContainer, AddFormButton } from "./TableElements";

const PaymentProcessingPopup = ({
  icon,
  message,
  showPopup,
  setShowPopup,
  onClose,
  actionIcon,
  listMsg,
  isLoading = false,
  processingMessage = "Processing payment...",
}) => {
  const handleOnHide = () => {
    if (onClose) {
      onClose();
    } else {
      setShowPopup(false);
    }
  };

  return (
    <Modal
      show={showPopup}
      onHide={handleOnHide}
      centered
      size="md"
      backdropClassName="custom-backdrop"
    >
      <Modal.Body className="d-flex flex-column">
        <div
          className="d-flex justify-content-end"
          style={{ width: "-webkit-fill-available" }}
        >
          <ActionIconContainer
            onClick={handleOnHide}
            id="close-payment-popup-icon-container"
          >
            <i className="fi fi-rr-cross-small" id="close-payment-popup-icon" />
          </ActionIconContainer>
        </div>
        <div className="d-flex gap-3 justify-content-start align-items-center p-2">
          {isLoading ? (
            <ProcessingSpinner>
              <Spinner animation="border" variant="primary" />
            </ProcessingSpinner>
          ) : (
            <InfoIcon
              className={`${icon.className} align-self-start`}
              color={icon.color}
              id="payment-icon"
            />
          )}
          <div>
            <p style={{ fontSize: "16px" }} id="payment-msg">
              {isLoading ? processingMessage : message}
            </p>
            {listMsg && (
              <ul>
                {listMsg.map((msg, i) => (
                  <li key={i} style={{ fontSize: "14px", fontWeight: 400 }}>
                    {msg}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {actionIcon && !isLoading && (
          <div className="d-flex justify-content-center align-items-center mt-2">
            <AddFormButton
              onClick={actionIcon.handler}
              type="button"
              id="payment-action-btn"
              style={{ width: "min-content" }}
            >
              {actionIcon.label}
            </AddFormButton>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PaymentProcessingPopup;

export const InfoIcon = styled.i`
  font-size: 32px;
  color: ${(p) => p.color};
  width: 32px;
  height: 32px;
  margin-bottom: 4px;
`;

export const ProcessingSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-bottom: 4px;
`;
